/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCapexDto } from '../../models/backend-actual-capex-dto';

export interface MonitoringActualsCapexsRetrieve$Params {
  id: number;
}

export function monitoringActualsCapexsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCapexsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCapexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCapexsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCapexDto>;
    }),
  );
}

monitoringActualsCapexsRetrieve.PATH = '/api/monitoring/actuals/capexs/{id}/';
